import IndividualTable from "../../../IndividualTable";
import { sampleData2 } from "../../sampleData";

const Distance90 = () => {
  return <IndividualTable matchType={"PRE"} gender="F" event="90" subTitle="TarscaShild" data={sampleData2} topRankCount="16" />;
};
export default Distance90;
